/**
 * Tela de conclusão (R19.2): mensagem de sucesso e botão de download proeminente
 * do EPUB final. O download é obtido sob demanda (`GET /jobs/{id}/download`) e
 * pode ser repetido (a URL pré-assinada expira em 15 min — R14.6).
 */
import { Alert } from "../Alert";
import { Button } from "../Button";
import { CheckIcon, DownloadIcon, SpinnerIcon } from "../Icons";

interface DoneScreenProps {
  readonly downloading: boolean;
  readonly downloadError: string | null;
  readonly onDownload: () => void;
  readonly onStartOver: () => void;
}

export function DoneScreen({ downloading, downloadError, onDownload, onStartOver }: DoneScreenProps) {
  return (
    <section className="mp-card" aria-labelledby="done-title">
      <div style={{ textAlign: "center" }}>
        <span className="mp-hero-icon mp-hero-icon--success" aria-hidden="true">
          <CheckIcon size={36} />
        </span>
      </div>
      <h1 className="mp-card__title" id="done-title" style={{ textAlign: "center" }}>
        Seu EPUB está pronto
      </h1>
      <p className="mp-card__subtitle" style={{ textAlign: "center" }}>
        A conversão foi concluída com sucesso. Baixe o arquivo abaixo.
      </p>

      {downloadError ? (
        <Alert tone="error" title="Não foi possível gerar o download">
          {downloadError}
        </Alert>
      ) : null}

      <div className="mp-actions">
        <Button
          variant="primary"
          className="mp-btn--block"
          onClick={onDownload}
          loading={downloading}
        >
          {downloading ? (
            <>
              <SpinnerIcon size={18} /> Preparando download…
            </>
          ) : (
            <>
              <DownloadIcon size={18} /> Baixar EPUB
            </>
          )}
        </Button>
        <Button variant="ghost" className="mp-btn--block" onClick={onStartOver}>
          Converter outro documento
        </Button>
      </div>
    </section>
  );
}
